// Running totals across every Visitor ID report (one per period; duplicate periods count once)
const weightedBuckets = (records, field, keyName = "range") => {
  const totals = {};
  let weight = 0;
  for (const r of records) {
    const w = Number(r.addresses_captured) || 0;
    if (!w || !(r[field] || []).length) continue;
    weight += w;
    for (const b of r[field]) totals[b[keyName]] = (totals[b[keyName]] || 0) + (Number(b.pct) || 0) * w;
  }
  return weight ? Object.entries(totals).map(([k, v]) => ({ [keyName]: k, pct: v / weight })) : [];
};

const summedCounts = (records, field, keyName) => {
  const totals = {};
  for (const r of records) for (const it of r[field] || []) totals[it[keyName]] = (totals[it[keyName]] || 0) + (Number(it.count) || 0);
  return Object.entries(totals).map(([k, count]) => ({ [keyName]: k, count })).sort((a, b) => b.count - a.count);
};

export const combineVisitorRecords = (records = []) => {
  const byPeriod = new Map();
  for (const r of records) {
    const key = `${r.report_start}__${r.report_end}`;
    if (!byPeriod.has(key)) byPeriod.set(key, r);
  }
  const list = [...byPeriod.values()];
  if (!list.length) return null;
  const sum = (f) => list.reduce((s, r) => s + (Number(r[f]) || 0), 0);
  return {
    start: list.map((r) => r.report_start).filter(Boolean).sort()[0],
    end: list.map((r) => r.report_end).filter(Boolean).sort().slice(-1)[0],
    reports: list.length,
    addresses_captured: sum("addresses_captured"),
    verified_emails: sum("verified_emails"),
    businesses_captured: sum("businesses_captured"),
    age_range: weightedBuckets(list, "age_range"),
    net_worth: weightedBuckets(list, "net_worth"),
    home_value: weightedBuckets(list, "home_value"),
    top_industries: summedCounts(list, "top_industries", "industry"),
    top_pages: summedCounts(list, "top_pages", "url"),
  };
};
